import { cn } from '@/lib/utils'

const marks = [
  ['mtbank', 'МТБанк'],
  ['webpay', 'WEBPAY'],
  ['visa', 'Visa'],
  ['visa-secure', 'Visa Secure'],
  ['mastercard', 'Mastercard'],
  ['mastercard-idcheck', 'Mastercard ID Check'],
  ['belkart', 'БЕЛКАРТ'],
  ['belkart-internet-parol', 'БЕЛКАРТ ИнтернетПароль'],
]

/** Official monochrome MTBank kit: readable in both themes, quiet beside the seller details. */
export function PaymentMarks({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-3', className)}>
      {marks.map(([name, label]) => (
        <span key={name} title={label} className="flex h-8 w-14 items-center justify-center">
          <img src={`/payment-marks/${name}-logo-gray.svg`} alt={label} width="56" height="28" loading="lazy" className="h-7 w-14 object-contain dark:hidden" />
          <img src={`/payment-marks/${name}-logo-white.svg`} alt={label} width="56" height="28" loading="lazy" className="hidden h-7 w-14 object-contain dark:block" />
        </span>
      ))}
    </div>
  )
}
